<jhi-custom-box [title]="title"
                [errorMsg]="errorMessage"
                [requiredFields]="false"
                [boxSize]="'box-550'"
                [successMsg]="successMessage"
                (failureEmitter)="redirectToHomepage()"
>


